import  { useEffect, useRef,memo } from "react";
import * as echarts from "echarts";
import styles from  './index.module.scss'
export interface echartsProps {
    id: string
    option: any
}
const MyCharts= (props: echartsProps) => {
const chartRef = useRef(); //拿到标记DOM容器，文档中是使用document获取dom。
 const {id, option} = props;
  // 监听props，props更换时重新绘制。
  useEffect(() => {
    const chart = echarts.init(document.getElementById(id));
    //将option放进 chart中
    chart.setOption(option);
  }, [option]);
 
  return (
    <div
    id={id}
      className={styles.chart}
      //目标dom中要记得写宽高
      style={{ height: "100%", width: "100%" }}
    ></div>
  );
};
 
export default memo(MyCharts);